export default "__VITE_ASSET__DqBNzQTr__"